import { Volume2, VolumeX } from 'lucide-react';
import { useAudioSettings } from '@/contexts/AudioSettingsContext';

export default function GlobalMuteButton() {
  const { isMuted, toggleMuted } = useAudioSettings();

  return (
    <button
      type="button"
      onClick={toggleMuted}
      aria-label={isMuted ? 'Unmute audio' : 'Mute audio'}
      title={isMuted ? 'Unmute' : 'Mute'}
      className="absolute right-4 top-[4.25rem] z-30 flex h-10 w-10 items-center justify-center rounded-full text-white/80 transition-colors hover:bg-white/10 hover:text-white"
    >
      {isMuted ? (
        <VolumeX size={22} strokeWidth={2.25} />
      ) : (
        <Volume2 size={22} strokeWidth={2.25} />
      )}
    </button>
  );
}
